module.exports = __webpack_public_path__ + "static/img/img.1c62127.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img.png
// module id = Tp5f
// module chunks = 1